import React from 'react';
import './addMember.scss'
import { shallowEqual, useSelector } from "react-redux";

import Title from '../../uiKit/Title/Title';
import AddMembersForm from '../../components/AddMembersForm/addMembersForm';
import { Breadcrumb } from '../../components/Breadcrumbs/breadcrumbs';

const AddMemberManual = () => {
    const screenWidth = useSelector(state => state.common.screenWidth, shallowEqual);

    return (
        <>
            <Breadcrumb title={'Forms'} />
            <div className='addMemberFormWrapper'>
                <Title
                    text='Fill in the Forms to Add Members'
                    fontSize={screenWidth < 900 ? 24 : 32}
                    lineHeight={42}
                    style={{ width: '270px' }}
                />
                <AddMembersForm />
            </div>
        </>
    )
}

export default AddMemberManual;